export enum EVENT_FOLLOWERS_SORTBY_ENUM {
  EMAIL = 'email',
  NAME = 'name',
  DATE = 'date',
}

export type FollowerFilterType = {
  id: string;
  PageNumber?: number;
  PageSize?: number;
  Term: string;
  sortBy: EVENT_FOLLOWERS_SORTBY_ENUM;
};

export const initialFilter: FollowerFilterType = {
  id: '',
  PageNumber: 1,
  PageSize: 100,
  Term: '',
  sortBy: EVENT_FOLLOWERS_SORTBY_ENUM.EMAIL,
};
